// extracted by mini-css-extract-plugin
module.exports = {"root":"EditProjectListingDescriptionPanel_root__2x7Ih","form":"EditProjectListingDescriptionPanel_form__1sr7q","title":"EditProjectListingDescriptionPanel_title__2Kx6T"};